module.exports = __webpack_public_path__ + "img/gh.985f0019.svg";